import type {ReactNode} from "react";

import {SheetHeader, SheetTitle} from "@/components/ui/sheet";

import {HelpTourTrigger} from "./help-tour-trigger";

type SheetHelpHeaderProps = {
  title: string;
  /** When set with `showCreateTour`, renders standard create-sheet tour trigger. */
  createTourId?: string;
  showCreateTour?: boolean;
  children?: ReactNode;
};

/**
 * DAR-standard sheet header: title + optional "Show me how" on create flows.
 */
export function SheetHelpHeader({
  title,
  createTourId,
  showCreateTour = false,
  children,
}: SheetHelpHeaderProps) {
  const showTour = showCreateTour && createTourId;

  return (
    <SheetHeader className="bg-background sticky top-0 z-10 flex shrink-0 flex-row items-center gap-2 border-b border-border/60 px-4 pb-3 pt-4 pr-12">
      <SheetTitle className="min-w-0 flex-1">{title}</SheetTitle>
      {children}
      {showTour ? <HelpTourTrigger tourId={createTourId} placement="sheet" /> : null}
    </SheetHeader>
  );
}
